module.exports = __webpack_public_path__ + "media/npc_dota_hero_nevermore.6690f483.webm";